"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const SvgNaturalDiamond = props => (0, jsx_runtime_1.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24.9,
  height: 24.9,
  ...props,
  children: (0, jsx_runtime_1.jsx)("g", {
    "data-name": "natural diamond",
    children: (0, jsx_runtime_1.jsx)("path", {
      "data-name": "Shape - Outline",
      d: "M12.401 21.868h-.01a.7.7 0 01-.535-.259L2.94 10.521l-.023-.1a.658.658 0 01-.012-.234v-.022a.691.691 0 01.1-.31l.008-.012 3.119-4.764a.709.709 0 01.568-.308h11.437a.7.7 0 01.569.312v.006l3.1 4.792a.759.759 0 01.085.269v.109a.492.492 0 01.007.058.486.486 0 01-.257.458l-8.701 10.83a.681.681 0 01-.539.263zM9.802 10.921l2.606 7.862 2.626-7.862zm6.71 0l-2.334 6.966 5.618-6.966zm-11.457 0l5.583 6.926-2.299-6.926zm11.294-1.394h3.614l-2.214-3.366h-3.936zm-11.462 0h3.606l2.531-3.366H7.085zm7.53-2.92l-2.186 2.914 4.374-.01z",
      fill: "#1c1c1c"
    })
  })
});
exports.default = SvgNaturalDiamond;